type AddressField =
  | "street"
  | "streetNumber"
  | "orientationNumber"
  | "postalCode"
  | "municipality";

const ADDRESS_FIELDS: ReadonlyArray<AddressField> = [
  "street",
  "streetNumber",
  "orientationNumber",
  "postalCode",
  "municipality",
];

/** Structural subset shared by AddressDto, AddressSuggestionDto, and form data. */
type AddressFieldSource = {
  [K in AddressField]?: string | null;
};

/**
 * Copies address fields into form fields. Works for any source with the
 * standard address shape (AddressDto, AddressSuggestionDto, etc.).
 * The `setField` callback receives each field name and its normalized value.
 */
export const copyAddressDtoToFormFields = (
  sourceAddress: AddressFieldSource,
  setField: (field: AddressField, value: string) => void,
) => {
  for (const field of ADDRESS_FIELDS) {
    setField(field, sourceAddress[field] ?? "");
  }
};

/** Structural subset of any address-shaped DTO used by `getFormattedAddress`. */
export type FormattableAddress = {
  street?: string | null;
  streetNumber?: string | null;
  orientationNumber?: string | null;
  postalCode?: string | null;
  municipality?: string | null;
};

export const getFormattedAddress = ({
  streetNumber,
  orientationNumber,
  street,
  postalCode,
  municipality,
}: FormattableAddress) => {
  const number = [streetNumber, orientationNumber].filter(Boolean).join("/");
  const firstPart = [street, number];
  const secondPart = [
    ...(postalCode ? [`${postalCode.slice(0, 3)} ${postalCode.slice(3)}`] : []),
    municipality,
  ];

  return [firstPart.join(" "), secondPart.join(" ")]
    .filter((s) => s.trim())
    .join(", ");
};
